<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ "Observación" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12> <b> Nombre completo:</b> {{ form.nombre }} </v-flex>
              <v-flex md12> <b>Item: </b> {{ form.item }} </v-flex> {{ form.id_persona }} 

              
            </v-layout>
          </v-container>

			<v-card-text>
			<h2><strong>Detalle observación</strong></h2>
			<v-layout>
						<v-flex xs12> 
							<v-data-table
								:items="seguimiento_observacion"
								class="elevation-1"
                noDataText="No hay resultados"
								hide-actions
								:headers="headers_detalle"
							>
								<template v-slot:items="props">
							<td class="text-xs-center">{{ props.item.fec_creado }} </td>
              <td class="text-xs-center">{{ props.item.estado }} </td>
							<td class="text-xs-center">{{ props.item.observacion }}</td>
							<td class="text-xs-center">{{ props.item.funcionario }}</td>

									
								</template>
							</v-data-table>
						</v-flex>
					</v-layout>			
			</v-card-text>


        </v-card-text>
        <!-- <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            :loading="loading"
            @click.native="save(39)"
            :disabled="!valid"
          >
            Aprobar
          </v-btn>
          <v-btn
            dark
            color="red"
            @click.native="save(40)"
            :loading="loading"
            :disabled="!valid"
          >
            Observar
          </v-btn>
        </v-card-actions> -->
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
	  id_persona:0,
	  item:[],
	  seguimiento_observacion:[],
	   headers_detalle: [
				{
					text: 'Fecha',
					sortable: false,
					align: 'center'
				},
        {
					text: 'Estado',
					sortable: false,
					align: 'center'
				},
				{
					text: 'Observación',
					sortable: false,
					align: 'center'
				},
				{
					text: 'Usuario',
					sortable: false,
					align: 'center'
				}
				
			],
    };
  },
  mounted() {
    this.$bus.$on("openDialogSeguimientoListaFicha", (item) => {
      this.form = item;
	//   console.log('ggggg'+this.form.id_persona)
	 //this.form.id_persona
	this.obtenerObservacion();
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      // this.valid = false
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save(id_nuevo_estado) {
      let resp = 0;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const user = this.$storage.get("user");
          let respuesta = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select persona.fn_estadoficha(${this.form.id_persona}, ${user.id},${id_nuevo_estado},'${this.form.observacion}')"){
								respuesta
							}
							}
						`,
          });
          resp = respuesta.runQuery.respuesta[0].fn_estadoficha;
        } catch (error) {
          console.log(error);
        }
        if (resp == 1) {
          this.$message.success();
        } else {
          this.$message.error();
        }
        this.loading = false;
        this.close();
      }
    },
	async obtenerObservacion () {
		
		//let id_persona=this.form.id_persona
		//console.log(this.form.id_persona);
      try {
          let res = await this.$service.graphql({
            query: `
              query{
                
                vSeguimientoObservas(id_persona: ${this.form.id_persona}, id_estado: 40){
							rows{
								id
						id_persona
						observacion
						id_estado
						fec_creado
						_user_created
						nombre_persona
						funcionario
						estado      
							}
						}
					}	
            `
          })
          this.seguimiento_observacion = res.vSeguimientoObservas.rows;
          //console.log(this.seguimiento_observacion)
        } catch (error) {
          console.log(error)
        }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/v_listaficha/dialogs/SeguimientoListaFicha.vue